import styled from "@emotion/styled";

export const ReplacementsShippingDetailsPageContent = styled.div(({ theme }) => ({
	padding: "16px 20px",
	h5: {
		margin: "0px 0px 16px",
		color: theme.project.colors.primaryColors.main
	},
	"> div:first-of-type": {
		marginBottom: 16
	}
}));
